import React from 'react';

const URL_OR_HASHTAG = /(\b(?:https?:\/\/|www\.)[^\s]+|#[\p{L}\p{N}_]+)/gu;

/**
 * Splits plain text into React nodes, wrapping URLs and hashtags
 * in the provided Link component. Each preview passes its own
 * platform-styled link (e.g. Facebook blue, Instagram navy).
 */
export function renderBodyWithLinks(
  text: string,
  Link: React.ComponentType<{ children: React.ReactNode }>,
): React.ReactNode[] {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  URL_OR_HASHTAG.lastIndex = 0;
  while ((match = URL_OR_HASHTAG.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(<Link key={match.index}>{match[0]}</Link>);
    lastIndex = URL_OR_HASHTAG.lastIndex;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts;
}
